import React, { useContext } from "react"
import { Search, SearchIconWrapper, StyledInputBase } from "./StyledComponents"
import { SearchContext } from "@/context/SearchContext"
import SearchIcon from "@mui/icons-material/Search"
import { Box, Typography } from "@mui/material"

export function SearchInput() {
  const { currentValue, setCurrentValue, setDialogOpen } = useContext(SearchContext)

  return (
    <Search>
      <SearchIconWrapper>
        <SearchIcon />
      </SearchIconWrapper>
      <StyledInputBase
        placeholder="Search by Address / Token / Profile / Pool"
        value={currentValue}
        autoFocus
        onChange={(e) => setCurrentValue(e.target.value)}
      />
      <Box
        sx={{
          position: "absolute",
          right: 8,
          top: "50%",
          transform: "translateY(-50%)",
          backgroundColor: "var(--mui-palette-background-default)",
          paddingX: 1,
          borderRadius: 1,
          border: "1px solid var(--mui-palette-divider)",
        }}
      >
        <Typography variant="caption" color="text.secondary">
          {navigator.userAgent.includes("Mac") ? "⌘ K" : "Ctrl K"}
        </Typography>
      </Box>
    </Search>
  )
}
